export const buttonSelectorPrefix = "html body #r3z-addoor .r3z-but";
